import React from 'react';

interface SectionTitleProps {
  title: string;
}

const SectionTitle = ({ title }: SectionTitleProps) => {
  return (
    <div className="mb-24 flex items-center md:mb-32">
      <div className="font-sans text-body-sm font-bold text-primary-red">{title}</div>
      <div className="ml-12 h-2 flex-1 bg-primary-red"></div>
    </div>
  );
};

export default SectionTitle;
